/**
 * @packageDocumentation
 *
 * Runs interop tests between Helia and Kubo.
 *
 * @example Testing a new Kubo release
 *
 * ```console
 * $ npm i @helia/interop
 * $ KUBO_BINARY=/path/to/kubo helia-interop
 * ```
 */

export {}
